import { render, staticRenderFns } from "./CBoxChart.vue?vue&type=template&id=76c05e71&scoped=true&"
import script from "./CBoxChart.vue?vue&type=script&lang=js&"
export * from "./CBoxChart.vue?vue&type=script&lang=js&"
import style0 from "./CBoxChart.vue?vue&type=style&index=0&id=76c05e71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c05e71",
  null
  
)

export default component.exports